import { render } from "./BaseForm.vue?vue&type=template&id=fa4c04b6"
import script from "./BaseForm.vue?vue&type=script&lang=js"
export * from "./BaseForm.vue?vue&type=script&lang=js"
script.render = render

export default script